'use client';

import React, { useRef, useState } from 'react';

import { CpToggleSwitch } from '@justgiving/carepack-forms';
import styles from './CoverVideo.module.scss';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { useTranslation } from 'react-i18next';

export type CoverVideoProps = {
  videoURL: string;
  chatUrl?: string;
};

export const CoverVideo: React.FC<CoverVideoProps> = ({
  videoURL,
  chatUrl,
}) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const intersection = useIntersectionObserver({ target: ref });
  const inView = intersection?.isIntersecting ?? true;
  const [chatVisible, setChatVisible] = useState(false);

  return (
    <div ref={ref} className={!inView ? styles.popout : ''}>
      <div className={styles.videoContainer}>
        <iframe
          src={videoURL}
          title={t('coverVideo.title')!}
          height="400"
          width="100%"
          allowFullScreen
          className={styles.video}
          frameBorder="0"
          scrolling="no"
        />
        {chatUrl && inView && (
          <div className={styles.chatToggle}>
            <CpToggleSwitch
              label={
                chatVisible ? t('coverVideo.chatOn') : t('coverVideo.chatOff')
              }
              checked={chatVisible}
              onChange={() => setChatVisible((v) => !v)}
            />
          </div>
        )}
      </div>
      {chatUrl && inView && chatVisible && (
        <iframe
          title={t('streamChat.title')!}
          src={chatUrl}
          height="320"
          width="100%"
          frameBorder="0"
          scrolling="no"
        />
      )}
    </div>
  );
};
